module.exports = __webpack_public_path__ + "fonts/motiva-sans-extra-bold.c7a0707.otf";